<template>
  <div class="vip-page">
    <section class="vip-hero">
      <div class="hero-copy">
        <span>VIP 俱乐部</span>
        <h1>VIP福利</h1>
        <p>累计充值可提升 VIP 等级，登录后可查看当前进度和等级权益。</p>
        <button @click="goVipAction">{{ loggedIn ? "去充值升级" : "登录查看VIP" }}</button>
      </div>
      <div class="level-orb">
        <div class="ring"></div>
        <strong>VIP {{ currentInfo.grade }}</strong>
        <em>{{ currentInfo.status }}</em>
      </div>
    </section>

    <section v-if="loggedIn" class="stats-grid">
      <article>
        <span>当前用户</span>
        <strong>{{ currentInfo.name }}</strong>
      </article>
      <article>
        <span>累计充值</span>
        <strong>{{ currentInfo.recharge }} <i></i></strong>
      </article>
      <article>
        <span>消费流水</span>
        <strong>{{ currentInfo.ls }} <i></i></strong>
      </article>
      <article>
        <span>下级还需</span>
        <strong>{{ currentInfo.gap }} <i></i></strong>
      </article>
    </section>

    <section v-if="loggedIn" class="progress-card">
      <div class="progress-head">
        <div>
          <span>下一级</span>
          <h2>VIP {{ nextGrade }}</h2>
        </div>
        <strong>{{ progressPercent }}%</strong>
      </div>
      <div class="progress-line">
        <i :style="{ width: progressPercent + '%' }"></i>
      </div>
      <div class="progress-meta">
        <span>当前 {{ currentInfo.recharge }}</span>
        <span>目标 {{ currentInfo.upgrade }}</span>
      </div>
      <p>{{ currentInfo.give }}，下一级奖励 {{ currentInfo.reward }} 披萨币。</p>
    </section>

    <section v-if="loggedIn" class="tier-section">
      <div class="section-title">
        <span></span>
        <h2>VIP等级奖励</h2>
      </div>
      <div class="tier-grid">
        <article
          v-for="tier in tierList"
          :key="tier.grade"
          class="tier-card"
          :class="{ active: tier.grade == currentInfo.grade }"
        >
          <div class="tier-top">
            <strong>VIP {{ tier.grade }}</strong>
            <em>{{ tier.reward }} <i></i></em>
          </div>
          <div class="tier-case">
            <span></span>
            <img src="/img/pizzaking/columns/backpack.png" alt="" />
          </div>
          <p>累计充值满 {{ tier.upgrade }} 披萨币</p>
        </article>
      </div>
    </section>

    <section v-else class="vip-auth-card">
      <img src="@/assets/hotpizza/hp-case-purple-transparent.png" alt="" />
      <div>
        <span>需要登录</span>
        <strong>登录后查看VIP进度</strong>
        <p>VIP 等级、累计充值和奖励信息均与当前账号关联，登录后可查看账户进度。</p>
      </div>
      <button @click="openLogin">登录账号</button>
    </section>
  </div>
</template>

<script>
export default {
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    return {
      currentInfo: {
        name: "",
        grade: 0,
        recharge: 0,
        ls: 0,
        gap: 0,
        upgrade: 0,
        reward: 0,
        status: "",
        give: "",
      },
      tierList: [],
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token);
    },
    nextGrade() {
      const next = this.tierList.find((tier) => tier.grade > this.currentInfo.grade);
      return next ? next.grade : this.currentInfo.grade;
    },
    progressPercent() {
      if (!this.currentInfo.upgrade) {
        return 100;
      }
      const percent = (Number(this.currentInfo.recharge) / Number(this.currentInfo.upgrade)) * 100;
      return Math.min(100, Math.floor(percent));
    },
  },
  mounted() {
    if (this.loggedIn) {
      this.getVipInfo();
      this.getVipReward();
    }
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.getVipInfo();
        this.getVipReward();
      }
    },
  },
  methods: {
    getVipInfo() {
      this.$axios
        .post("/index/Lucky/vipInfo", this.$qs.stringify({}))
        .then((res) => {
          if (res.data.status == 1) {
            this.currentInfo = res.data.data.list[0];
          }
        });
    },
    getVipReward() {
      this.$axios
        .post("/index/Lucky/vipreward", this.$qs.stringify({ page: 1, pageSize: 50 }))
        .then((res) => {
          if (res.data.status == 1) {
            this.tierList = res.data.data.list;
          }
        });
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
    goVipAction() {
      if (this.loggedIn) {
        this.goPath("/Payment");
      } else {
        this.openLogin();
      }
    },
    goPath(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.vip-page {
  min-height: calc(100vh - 198px);
  padding: 26px 26px 70px;
  color: #f4f7ff;
  background:
    radial-gradient(circle at 52% 0, rgba(255, 136, 31, 0.18), transparent 36%),
    radial-gradient(circle at 88% 28%, rgba(0, 220, 255, 0.12), transparent 28%),
    linear-gradient(180deg, #1d202c 0%, #171923 100%);
}

button {
  font-family: inherit;
}

.vip-hero,
.stats-grid,
.progress-card,
.tier-section,
.vip-auth-card {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.vip-hero {
  min-height: 300px;
  padding: 42px 52px;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 28px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 132, 31, 0.32);
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(38, 41, 57, 0.96), rgba(23, 25, 35, 0.96)),
    url("../assets/new/task_bg.png") center / cover;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.36);
}

.vip-hero::after {
  content: "";
  width: 520px;
  height: 520px;
  position: absolute;
  right: -110px;
  top: -160px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 129, 22, 0.34), transparent 66%);
}

.hero-copy {
  position: relative;
  z-index: 1;
}

.hero-copy span,
.progress-head span,
.section-title span {
  color: #ff8a1f;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.hero-copy h1 {
  margin: 12px 0 16px;
  font-size: 56px;
  line-height: 1;
  font-weight: 1000;
}

.hero-copy p {
  max-width: 560px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
}

.hero-copy button {
  height: 46px;
  margin-top: 24px;
  padding: 0 24px;
  color: #fff;
  background: linear-gradient(180deg, #ff9b20, #f16b00);
  border: 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(241, 107, 0, 0.28);
}

.level-orb {
  width: 250px;
  height: 250px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background:
    radial-gradient(circle, rgba(255, 209, 112, 0.28), rgba(255, 112, 24, 0.08) 58%, transparent 60%),
    #222636;
  box-shadow: inset 0 0 42px rgba(255, 150, 31, 0.16), 0 32px 70px rgba(0, 0, 0, 0.36);
}

.level-orb .ring {
  width: 286px;
  height: 122px;
  position: absolute;
  border-bottom: 1px solid rgba(255, 216, 142, 0.38);
  border-radius: 50%;
}

.level-orb strong {
  color: #fff4d0;
  font-size: 46px;
}

.level-orb em {
  margin-top: 8px;
  color: #9da6b9;
  font-style: normal;
  font-weight: 900;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-top: 22px;
  margin-bottom: 22px;
}

.stats-grid article,
.progress-card,
.tier-card {
  border: 1px solid #34384b;
  border-radius: 16px;
  background: #242737;
}

.stats-grid article {
  min-height: 116px;
  padding: 22px;
}

.stats-grid span {
  color: #8d96aa;
  font-size: 13px;
}

.stats-grid strong {
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #fff4d0;
  font-size: 26px;
}

.stats-grid i,
.tier-top i {
  width: 14px;
  height: 14px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.progress-card {
  padding: 26px;
  margin-bottom: 26px;
}

.progress-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.progress-head h2 {
  margin: 6px 0 0;
  font-size: 28px;
}

.progress-head strong {
  color: #ffbf64;
  font-size: 30px;
}

.progress-line {
  height: 14px;
  margin: 22px 0 12px;
  overflow: hidden;
  border-radius: 99px;
  background: #303445;
}

.progress-line i {
  height: 100%;
  display: block;
  border-radius: 99px;
  background: linear-gradient(90deg, #ff7a00, #ffd36e);
  box-shadow: 0 0 22px rgba(255, 154, 37, 0.46);
}

.progress-meta {
  display: flex;
  justify-content: space-between;
  color: #9da6b9;
}

.progress-card p {
  margin: 18px 0 0;
  color: #c1c8d8;
}

.vip-auth-card {
  min-height: 250px;
  margin-top: 18px;
  padding: 30px;
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;
  background:
    radial-gradient(circle at 12% 50%, rgba(255, 138, 31, 0.24), transparent 34%),
    linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 132, 31, 0.24);
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
}

.vip-auth-card img {
  width: 180px;
  max-height: 150px;
  object-fit: contain;
  filter: drop-shadow(0 20px 28px rgba(255, 138, 31, 0.22));
}

.vip-auth-card span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.vip-auth-card strong {
  display: block;
  margin-top: 8px;
  color: #fbfcff;
  font-size: 30px;
  font-weight: 1000;
}

.vip-auth-card p {
  max-width: 560px;
  margin: 10px 0 0;
  color: #aeb7c8;
  font-size: 15px;
  line-height: 1.7;
  font-weight: 800;
}

.vip-auth-card button {
  height: 44px;
  padding: 0 24px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 8px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 14px 34px rgba(255, 131, 0, 0.24);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.section-title span {
  width: 8px;
  height: 8px;
  display: block;
  border-radius: 50%;
  background: #ff8a1f;
  box-shadow: 0 0 16px #ff8a1f;
}

.section-title h2 {
  margin: 0;
  font-size: 24px;
}

.tier-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.tier-card {
  min-height: 230px;
  padding: 18px;
  position: relative;
  overflow: hidden;
}

.tier-card.active {
  border-color: #ff8a1f;
  box-shadow: 0 0 0 1px rgba(255, 138, 31, 0.24), 0 16px 42px rgba(255, 110, 0, 0.14);
}

.tier-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tier-top strong {
  color: #fff;
  font-size: 20px;
}

.tier-top em {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffbf64;
  font-style: normal;
  font-weight: 900;
}

.tier-case {
  height: 120px;
  margin: 16px 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tier-case span {
  width: 170px;
  height: 78px;
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 151, 44, 0.24), transparent 65%);
  border-bottom: 1px solid rgba(255, 207, 132, 0.28);
}

.tier-case img {
  width: 128px;
  height: 92px;
  object-fit: contain;
  position: relative;
  filter: drop-shadow(0 18px 26px rgba(255, 136, 31, 0.22));
}

.tier-card p {
  color: #9da6b9;
  font-size: 13px;
  line-height: 1.6;
}

@media screen and (max-width: 980px) {
  .vip-hero,
  .stats-grid,
  .tier-grid {
    grid-template-columns: 1fr 1fr;
  }

  .vip-auth-card {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 640px) {
  .vip-page {
    padding: 18px 12px 42px;
  }

  .vip-hero,
  .stats-grid,
  .tier-grid,
  .vip-auth-card {
    grid-template-columns: 1fr;
  }

  .vip-hero {
    padding: 32px 22px;
  }

  .hero-copy h1 {
    font-size: 42px;
  }
}
</style>

<style lang="less">
.vip-page {
  padding: 32px 28px 96px !important;
}

.vip-page .vip-hero,
.vip-page .stats-grid,
.vip-page .progress-card,
.vip-page .tier-section,
.vip-page .vip-auth-card {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.vip-page .vip-hero {
  min-height: 326px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.vip-page .level-orb {
  width: 278px !important;
  height: 278px !important;
}

.vip-page .level-orb .ring {
  width: 318px !important;
  height: 140px !important;
}

.vip-page .stats-grid {
  gap: 16px !important;
}

.vip-page .tier-grid {
  grid-template-columns: repeat(auto-fill, minmax(232px, 1fr)) !important;
  gap: 16px !important;
}

.vip-page .tier-card {
  min-height: 286px !important;
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.vip-page .tier-case img {
  width: 172px !important;
  filter:
    drop-shadow(0 20px 26px rgba(0, 0, 0, 0.42))
    drop-shadow(0 0 20px rgba(255, 138, 0, 0.18)) !important;
}

@media screen and (max-width: 980px) {
  .vip-page {
    padding: 18px 12px 58px !important;
  }

  .vip-page .vip-hero,
  .vip-page .stats-grid,
  .vip-page .progress-card,
  .vip-page .tier-section,
  .vip-page .vip-auth-card {
    width: 100% !important;
  }
}

/* 2026-07-05 exact internal pass: VIP reward center. */
.vip-page {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(ellipse at 50% 170px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

.vip-page .vip-hero,
.vip-page .stats-grid,
.vip-page .progress-card,
.vip-page .tier-section,
.vip-page .vip-auth-card {
  width: 100% !important;
  max-width: none !important;
}

.vip-page .vip-hero {
  min-height: 286px !important;
  padding: 30px 38px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 74% 52%, rgba(255, 138, 31, 0.14), transparent 48%),
    #20222f !important;
  box-shadow: none !important;
}

.vip-page .hero-copy h1 {
  color: #f4ead8 !important;
  font-size: 52px !important;
}

.vip-page .stats-grid article,
.vip-page .progress-card,
.vip-page .tier-card,
.vip-page .vip-auth-card {
  border-color: #2b2d3c !important;
  background: #20222f !important;
}

.vip-page .tier-grid {
  grid-template-columns: repeat(auto-fill, minmax(204px, 1fr)) !important;
  gap: 10px !important;
}

.vip-page .tier-card {
  min-height: 252px !important;
  border-radius: 8px !important;
}

.vip-page .tier-case img {
  width: 150px !important;
}
</style>
